import useGetInHouseJackpotSettings from '../../../../hooks/useGetInHouseJackpotSettings';
import { useGetJackpotCurrency } from '../../../../jackpotsStore';

export const useGetIsJackpotCentsHidden = () => {
  const jackpotCurrency = useGetJackpotCurrency();
  const { currenciesWithHiddenCents } = useGetInHouseJackpotSettings();

  return currenciesWithHiddenCents?.includes(jackpotCurrency);
};
